import React, { createRef, useEffect, useState } from 'react';

import NearbyPlaces from 'common/components/NearbyPlaces/NearbyPlaces';
import IconsMapper from 'common/components/IconsMapper/IconsMapper';

import './NearbyPlacesWrapper.css';

const NearbyPlacesDetails = ({ nearbyMerchants }) => {
  return (
    <ul aria-label="Liste des salons à proximité">
      {nearbyMerchants.map((merchant) => {
        return (
          <li key={merchant.id}>
            <a
              href={merchant.localpageUrl}
              aria-label={`Visiter la page de ${merchant.name}`}
            >
              <strong className="nearbyPlacesDetailsName">
                {merchant.name}
              </strong>
              <address style={{ fontWeight: 400 }}>
                {merchant.formattedAddress}
              </address>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

const Child = ({ nearbyMerchants }) => {
  const details = createRef();
  const [isDisplayed, setIsDisplayed] = useState(false);
  const displayDetails = () => {
    setIsDisplayed(!isDisplayed);
  };

  useEffect(() => {
    if (details.current) {
      details.current.style.display = isDisplayed ? 'block' : 'none';
    }
  }, [isDisplayed, details]);

  return (
    <section
      className="nearbyPlacesWrapperSection"
      aria-labelledby="nearby-places-title"
    >
      <button
        type="button"
        className="nearbyPlacesWrapperContainer"
        onClick={() => displayDetails()}
        aria-expanded={isDisplayed}
        aria-controls="nearby-places-list"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          width: '100%',
        }}
      >
        <span className="nearbyPlacesCenter" aria-hidden="true">
          <IconsMapper icon={'faLocationDot'}></IconsMapper>
        </span>
        <h3
          id="nearby-places-title"
          className="sl-title sl-text-l sl-text-center"
        >
          SALONS À PROXIMITÉ
        </h3>
        <span
          className="nearbyPlacesCenter"
          aria-hidden="true"
          style={
            isDisplayed
              ? {
                  transition: '0.3s',
                }
              : {
                  transform: 'rotate(90deg)',
                  transition: '0.3s',
                }
          }
        >
          <IconsMapper icon={'faChevronDown'}></IconsMapper>
        </span>
      </button>

      <div
        id="nearby-places-list"
        className="nearbyPlacesDetailsWrapper"
        ref={details}
        style={{ display: 'none' }}
        role="navigation"
        aria-label="Navigation vers les salons à proximité"
      >
        <NearbyPlacesDetails
          nearbyMerchants={nearbyMerchants}
        ></NearbyPlacesDetails>
      </div>
    </section>
  );
};

const NearbyPlacesWrapper = () => {
  return <NearbyPlaces children={<Child></Child>}></NearbyPlaces>;
};

export default NearbyPlacesWrapper;
